import styled from 'styled-components';

export const TagsContentListTitle = styled.dt`
  display: flex;
  align-items: start;
  min-height: 38px;
  margin-top: 10px;
`;
